import environment from "../environment";
import { POST } from "./http.service";

const _endpoint = environment.GALLERY_ENDPOINT;

export const getBestGalleryImage = async (requestBody) => {
  const response = await POST(`Course/gallery`, requestBody, false);
  return response;
};
